import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsx jsx */
import React, { forwardRef, useMemo } from 'react';
import { jsx } from '@emotion/core';
import GlobalTheme from '@atlaskit/theme/components';
import { actionsStyle, containerStyle, contentContainerStyle, iconWrapperStyle, titleStyle } from './internal/styles';
import { appearanceIconTheming } from './internal/styles/theme';
import SectionMessageAction from './section-message-action';
var defaultActions = [];

function getAppearanceIconTheme(appearance, icon) {
  var appearanceIconTheme = appearanceIconTheming[appearance] || appearanceIconTheming.info;
  var Icon = icon || appearanceIconTheme.Icon;
  return _objectSpread(_objectSpread({}, appearanceIconTheme), {}, {
    Icon: Icon
  });
}

var SectionMessageWithMode = /*#__PURE__*/forwardRef(function SectionMessage(_ref, ref) {
  var children = _ref.children,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'info' : _ref$appearance,
      _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? defaultActions : _ref$actions,
      title = _ref.title,
      icon = _ref.icon,
      linkComponent = _ref.linkComponent,
      testId = _ref.testId,
      mode = _ref.mode;

  var _getAppearanceIconThe = getAppearanceIconTheme(appearance, icon),
      backgroundColor = _getAppearanceIconThe.backgroundColor,
      primaryIconColor = _getAppearanceIconThe.primaryIconColor,
      Icon = _getAppearanceIconThe.Icon;

  var containerStyleWithBackground = useMemo(function () {
    return containerStyle(backgroundColor);
  }, [backgroundColor]);
  var memoizedTitleStyle = useMemo(function () {
    return titleStyle(mode);
  }, [mode]);
  return jsx("section", {
    css: containerStyleWithBackground,
    "data-testid": testId,
    ref: ref
  }, jsx("div", {
    css: iconWrapperStyle
  }, jsx(Icon, {
    primaryColor: primaryIconColor,
    secondaryColor: backgroundColor
  })), jsx("div", {
    css: contentContainerStyle
  }, title ? jsx("h1", {
    css: memoizedTitleStyle
  }, title) : null, jsx("div", null, children), actions.length > 0 ? jsx("ul", {
    css: actionsStyle
  }, actions.map(function (action) {
    return jsx(SectionMessageAction, {
      text: action.text,
      onClick: action.onClick,
      href: action.href,
      key: action.key,
      testId: action.testId,
      linkComponent: linkComponent
    });
  })) : null));
});
var SectionMessage = /*#__PURE__*/forwardRef(function SectionMessage(props, ref) {
  return jsx(GlobalTheme.Consumer, null, function (_ref2) {
    var mode = _ref2.mode;
    return jsx(SectionMessageWithMode, _extends({}, props, {
      mode: mode,
      ref: ref
    }));
  });
});
SectionMessage.displayName = 'SectionMessage';
export default SectionMessage;